import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { FAB_SURGE_GET_USER_SUMMARY, FAB_SURGE_GET_USER_SUMMARY_ERROR, FAB_SURGE_GET_USER_SUMMARY_SUCCESS } from '../../../actions.js';

function* getFabUserSummary({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin-users-summary`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: FAB_SURGE_GET_USER_SUMMARY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: FAB_SURGE_GET_USER_SUMMARY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: FAB_SURGE_GET_USER_SUMMARY_ERROR, payload: error });
  }
}

export function* watchgetFabUserSummary() {
  yield takeEvery(FAB_SURGE_GET_USER_SUMMARY, getFabUserSummary);
}

function* getFabUserSummarySaga() {
  yield all([fork(watchgetFabUserSummary)]);
}

export default getFabUserSummarySaga;
